import { observable } from 'mobx';

export type TaskalCallFeeResponseArgs = {
  id: number;
  call_date: string | null;
  day_of_week: string | null;
  call_time_jst: string | null;
  reservation_number: string | null;
  counterpart_company_name: string | null;
  call_recipient_name: string | null;
  person_in_charge: string | null;
  incoming_call_count: number | null;
  amount: number | null;
  trip_id: number | null;
  organization_name: string | null;
  created_at: string | null;
};

export type TaskalCallFeeArgs = {
  id: number;
  callDate: string | null;
  dayOfWeek: string | null;
  callTimeJst: string | null;
  reservationNumber: string | null;
  counterpartCompanyName: string | null;
  callRecipientName: string | null;
  personInCharge: string | null;
  incomingCallCount: number | null;
  amount: number | null;
  tripId: number | null;
  organizationName: string | null;
  createdAt: string | null;
};

export const convertTaskalCallFeeResponseToArgs = (response: TaskalCallFeeResponseArgs): TaskalCallFeeArgs => ({
  id: response.id,
  callDate: response.call_date,
  dayOfWeek: response.day_of_week,
  callTimeJst: response.call_time_jst,
  reservationNumber: response.reservation_number,
  counterpartCompanyName: response.counterpart_company_name,
  callRecipientName: response.call_recipient_name,
  personInCharge: response.person_in_charge,
  incomingCallCount: response.incoming_call_count,
  amount: response.amount,
  tripId: response.trip_id,
  organizationName: response.organization_name,
  createdAt: response.created_at
});

export type TaskalCallFeeUpdateSubmitArgs = {
  trip_id?: number | null;
  amount?: number;
};

export default class TaskalCallFee {
  @observable id: number;
  @observable callDate: string | null;
  @observable dayOfWeek: string | null;
  @observable callTimeJst: string | null;
  @observable reservationNumber: string | null;
  @observable counterpartCompanyName: string | null;
  @observable callRecipientName: string | null;
  @observable personInCharge: string | null;
  @observable incomingCallCount: number | null;
  @observable amount: number | null;
  @observable tripId: number | null;
  @observable organizationName: string | null;
  @observable createdAt: string | null;

  constructor(args: TaskalCallFeeArgs) {
    this.id = args.id;
    this.callDate = args.callDate;
    this.dayOfWeek = args.dayOfWeek;
    this.callTimeJst = args.callTimeJst;
    this.reservationNumber = args.reservationNumber;
    this.counterpartCompanyName = args.counterpartCompanyName;
    this.callRecipientName = args.callRecipientName;
    this.personInCharge = args.personInCharge;
    this.incomingCallCount = args.incomingCallCount;
    this.amount = args.amount;
    this.tripId = args.tripId;
    this.organizationName = args.organizationName;
    this.createdAt = args.createdAt;
  }
}
